import React from "react";
import { Timeline } from "@bookingcom/bui-react";
import { FlightTimelinePointUI } from "./FlightTimelinePoint.ui.js";
import { FlightTimelineContentUI } from "./FlightTimelineContent.ui.js";
export function FlightTimelineUI(props) {
    const { items, ...timelineprops } = props;
    return (React.createElement(Timeline, { ...timelineprops }, items
        .map((item, idx) => {
        const nextItem = items?.[idx + 1];
        const nextItemIsContent = nextItem?.type === "content";
        const lineVariant = nextItemIsContent ? "dashed" : undefined;
        if (item.type === "content")
            return undefined;
        return (React.createElement(Timeline.Item, { key: idx, lineVariant: lineVariant },
            React.createElement(FlightTimelinePointUI, { ...item, content: nextItemIsContent ? React.createElement(FlightTimelineContentUI, { ...nextItem }) : item.content })));
    })
        .filter(Boolean)));
}
